import { Component } from '@mycolorway/tao';
import { matches } from 'next/javascripts/modules/dom';

Component('tr-pagination', {
  connected() {
    Array.prototype.forEach.call(this.querySelectorAll('.page a'), (link) => {
      if (matches(link, '[data-remote]')) {
        link.setAttribute('data-type', 'script');
      }
    });
  },
});
